<template>
  <div class="offline-indicator-container">
    <span class="offline-indicator">
      You are no longer online.
    </span>
  </div>
</template>

<script>
export default {
  name: "OfflineIndicator",
  props: {
    msg: String
  },
  computed: {},
  updated() {},
  methods: {}
};
</script>

<style scoped lang="stylus">
div.offline-indicator-container{
  z-index: 1050;
  text-align: center;
}
span.offline-indicator{
  z-index: 1051;
  background: #ff8c00;
  color: #fff;
  padding: 0.2rem;
  width: 12rem;
  position: absolute;
  top: 3.5rem;
}
</style>
